<template>
  <v-container fluid ma-0 pa-0>
    <v-row ma-0 pa-0 class="footer">
      <v-col class="py-md-0 col-md-2 offset-md-1 col-12">
        <v-img :src="logoFooter" />
        <p v-html="excerptFooter"></p>
      </v-col>
      <template v-for="(menu, i) in footerMenu">
        <v-col :key="i" class="py-md-0 col-md-2 col-12">
          <h3 v-html="menu.title"></h3>
          <ul>
            <li v-for="(item, j) in menu.items" :key="j">
              <router-link
                v-if="!item.external"
                :to="item.link"
                @click="
                  $analytics(item.eventCategory, 'click', item.eventLabel)
                "
              >
                {{ item.name }}
              </router-link>
              <a
                v-else
                :href="item.link"
                target="_blank"
                @click="
                  $analytics(item.eventCategory, 'click', item.eventLabel)
                "
              >
                {{ item.name }}
              </a>
            </li>
          </ul>
        </v-col>
      </template>
      <v-col class="py-md-0 col-md-2 col-12">
        <h3>Contato</h3>
        <ul>
          <li>
            <a href="mailto:atendimento@eureciclo.com.br" rel="noreferrer"
              >atendimento@eureciclo.com.br</a
            >
          </li>
        </ul>
        <h3>Assessoria de imprensa</h3>
        <ul>
          <li>
            <a href="mailto:eureciclo@inpresspni.com.br" rel="noreferrer"
              >eureciclo@inpresspni.com.br</a
            >
          </li>
        </ul>
        <ul class="social-list">
          <li v-for="(item, i) in social" :key="i">
            <a
              class="icon"
              :href="item.href"
              target="_blank"
              rel="noreferrer"
              @click="$analytics(item.eventCategory, 'click', item.eventLabel)"
            >
              <img
                :src="item.image"
                :alt="item.eventLabel"
                width="20"
                height="20"
              />
            </a>
          </li>
        </ul>
      </v-col>
      <v-col class="py-md-0 offset-md-1 col-md-10 col-12">
        <ul class="prizes-list">
          <li v-for="(item, i) in prizes" :key="i">
            <a v-if="item.href" :href="item.href" target="_blank">
              <v-img
                contain
                max-height="100"
                max-width="100"
                :src="item.image"
                :alt="item.eventLabel"
                style="margin-left: 50px"
              />
              <p>
                Asseguração limitada do volume de resíduos do processo de
                certificação de logística reversa
              </p>
            </a>
            <v-img
              v-else
              :key="i"
              contain
              max-height="100"
              max-width="100"
              :src="item.image"
              :alt="item.eventLabel"
            />
          </li>
        </ul>
      </v-col>
      <v-col class="offset-md-1 col-md-10 col-12 rights">
        <span
          >©{{ year }} eureciclo.com.br - NEW HOPE ECOTECH NEGOCIOS SOCIAIS E
          GESTAO EMPRESARIAL LTDA., CNPJ: 21.602.471/0001-40 - Endereço: Avenida
          Angelica, 2529 -CONSOLAÇÃO, SÃO PAULO-SP - CEP: 01227-200</span
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LogoFooter',
  data() {
    return {
      logoFooter: require('@/assets/images/footer/logo-footer.png'),
      excerptFooter:
        'Conectamos empresas a recicladores para compensar o impacto ambiental das embalagens vendidas no Brasil.',
      footerMenu: [
        {
          title: 'Negócios',
          items: [
            {
              name: 'pequenas empresas',
              link: '/empreendedores',
              eventCategory: 'Negócios',
              eventLabel: 'choose-empreendedores',
            },
            {
              name: 'médias e grandes empresas',
              link: '/corporacoes',
              eventCategory: 'Negócios',
              eventLabel: 'choose-corporacoes',
            },
            {
              name: 'associações',
              link: '/associacoes',
              eventCategory: 'Negócios',
              eventLabel: 'choose-associações',
            },
            {
              name: 'centrais de triagem',
              link: '/centrais-de-triagem',
              eventCategory: 'Negócios',
              eventLabel: 'choose-centrais-de-triagem',
            },
          ],
        },
        {
          title: 'Acessos',
          items: [
            {
              name: 'área do cliente',
              link: 'https://empresas.nhecotech.com',
              eventCategory: 'Acessos',
              eventLabel: 'choose-area-do-cliente',
              external: true,
            },
            {
              name: 'área do operador',
              link: 'https://eureciclo.operadores.com.br',
              eventCategory: 'Acessos',
              eventLabel: 'choose-area-do-operador',
              external: true,
            },
            {
              name: 'seja um consultor eureciclo',
              link: '/consultores',
              eventCategory: 'Acessos',
              eventLabel: 'choose-consultores',
            },
            {
              name: 'trabalhe conosco',
              link: '/trabalhe-conosco',
              eventCategory: 'Acessos',
              eventLabel: 'choose-trabalhe-conosco',
            },
          ],
        },
        {
          title: 'Compliance',
          items: [
            {
              name: 'código de conduta',
              link: '/codigo-de-conduta',
              eventCategory: 'Compliance',
              eventLabel: 'choose-codigo-de-conduta',
            },
            {
              name: 'código de ética',
              link: '/codigo-de-etica',
              eventCategory: 'Compliance',
              eventLabel: 'choose-codigo-de-etica',
            },
            {
              name: 'política socioambiental e de governança corporativa (ESG)',
              link: '/politica-socioambiental-e-de-governanca-corporativa-ESG',
              eventCategory: 'Compliance',
              eventLabel:
                'choose-politica-socioambiental-e-de-governanca-corporativa-ESG',
            },
            {
              name: 'código de princípios de negócios',
              link: '/codigo-de-principios-de-negocios',
              eventCategory: 'Compliance',
              eventLabel: 'choose-codigo-de-principios-de-negocios',
            },
            {
              name: 'política de compliance',
              link: '/politica-de-compliance',
              eventCategory: 'Compliance',
              eventLabel: 'choose-politica-de-compliance',
            },
          ],
        },
        // {
        //   name: 'consumidores',
        //   link: '/consumidores',
        //   eventLabel: 'choose-consumidores',
        // },
        // {
        //   name: 'termos e condições',
        //   link: '/termos-e-condicoes',
        //   eventLabel: 'choose-termos-de-uso',
        // },
        // {
        //   name: 'política de privacidade',
        //   link: '/politica-de-privacidade',
        //   eventLabel: 'choose-politica-de-privacidade',
        // },
      ],
      social: [
        {
          eventCategory: 'Social',
          eventLabel: 'facebook',
          href: 'https://www.facebook.com/seloeureciclo',
          image: require('@/assets/images/footer/facebook.png'),
        },
        {
          eventCategory: 'Social',
          eventLabel: 'instagram',
          href: 'https://www.instagram.com/seloeureciclo/',
          image: require('@/assets/images/footer/instagram.png'),
        },
        {
          eventCategory: 'Social',
          eventLabel: 'twitter',
          href: 'https://www.twitter.com',
          image: require('@/assets/images/footer/twitter.png'),
        },
        {
          eventCategory: 'Social',
          eventLabel: 'youtube',
          href: 'https://www.youtube.com/channel/UC10lLIfLJQOMW_2Ul7ZutDg',
          image: require('@/assets/images/footer/youtube.png'),
        },
        {
          eventCategory: 'Social',
          eventLabel: 'linkedin',
          href: 'https://www.linkedin.com/company/seloeureciclo',
          image: require('@/assets/images/footer/linkedin.png'),
        },
        {
          eventCategory: 'Social',
          eventLabel: 'podcast',
          href:
            'https://open.spotify.com/show/5lOYAHEvWSaf4r55PK5qA3?si=eTOhNHpIQnaQwKYSVVNp6w',
          image: require('@/assets/images/footer/spotify.png'),
        },
      ],
      prizes: [
        {
          eventCategory: 'Prêmios',
          eventLabel: 'Empresa B',
          image: require('@/assets/images/logo-empresaB.png'),
        },
        {
          eventCategory: 'Prêmios',
          eventLabel: 'EY',
          href: `${window.location.origin}/material/carta-de-asseguracao-2021-2022.pdf`,
          image: require('@/assets/images/logo-ey.png'),
        },
        {
          eventCategory: 'Prêmios',
          eventLabel: 'BBB Humanizadas',
          image: require('@/assets/images/footer/bbb_humanizadas-white.png'),
        },
        {
          eventCategory: 'Prêmios',
          eventLabel: 'BFTW 2022 comunidade',
          image: require('@/assets/images/footer/bftw-2022-comunidade.png'),
        },
      ],
    };
  },
  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'

.footer
  background-color: #003036
  padding: 90px 0 45px
  margin: 0
  .v-image
    max-width: 200px
    margin-bottom: 25px
  p,
  a
    font-family: 'metropolisregular'
    font-style: normal
    font-weight: 400
    font-size: 12px
    line-height: 1.4
    color: #FFFFFF
  a
    outline: none
    text-decoration: none
  h3
    font-family: 'metropolisbold'
    font-style: normal
    font-weight: 700
    font-size: 12px
    line-height: 1
    color: #FFFFFF
    margin-bottom: 10px
  ul
    position: relative
    display: block
    padding: 0
    margin: 0
    list-style-type: none
    &.social-list
      display: flex
      gap: 10px
      margin-top: 30px
      li
        line-height: 1
        margin-bottom: 0
        a
          position: relative
          display: block
          width: 100%
          height: 100%
          text-decoration: none
          outline: none
          line-height: 1
    &.prizes-list
      display: flex
      justify-content: center
      gap: 20px
      li
        p
          max-width: 200px
          text-align: center
    li
      position: relative
      display: block
      font-family: 'metropolisregular'
      font-style: normal
      font-weight: 400
      font-size: 12px
      line-height: 1.4
      color: #FFFFFF
      margin-bottom: 10px
      a
        transition: all 300ms ease-in-out
        &:hover
          text-decoration: underline
          transition: all 300ms ease-in-out
  .rights
    position: relative
    border-top: 1px solid #CDCDD0
    padding-top: 25px
    margin-top: 80px
    span
      position: relative
      display: block
      font-family: 'metropolisregular'
      font-style: normal
      font-weight: 400
      font-size: 12px
      line-height: 1.4
      color: #FFFFFF
  @media screen and (max-width: 959px)
    ul
      &.prizes-list
        flex-flow: column
        align-items: center
</style>
